import React, { useState, useEffect } from 'react';
import { Button, Modal, Box, Typography, TextField, CircularProgress } from '@mui/material';
import alertIcon from '../../src/img/warning-icon.svg'
import * as Yup from 'yup'; 
import { useHistory } from "react-router-dom";
import {useResolveEscalationApiMutation} from "../services/jobsApi.js";

const SaveAndSetAsActive = ({ userCanEditJob, escalation, user, resolveOptions, issueResolvedNote, saveChanges, fetching, setFetching, getJobInfo }) => {

  const history = useHistory();
  
  useEffect(() => {
    setInternalNote(issueResolvedNote); 
  }, [issueResolvedNote]);

  const [initResolveEscalationApi, {isLoading: resolveEscalationApiIsLoading}] = useResolveEscalationApiMutation();

  const [open, setOpenModal] = useState(false);
  const [internalNote, setInternalNote] = useState();
  const [error, setError] = useState(''); 

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setError('');
  };

  const validationSchema = Yup.object().shape({
    internalNote: Yup.string()
      .required('Please enter an Internal Note.')
  });
  
  const SaveChanges = async () => {
    let resolveEscal = {
      escalationId: escalation.id,
      stnUserId: user.id,
      issueResolvedNote: internalNote,
      jobStatusName: "Active",
      returnJobToBee: resolveOptions == "returnToOwner"
    };

    try {
      await validationSchema.validate({ internalNote });

      saveChanges("SaveAndSetAsActive");

      await initResolveEscalationApi(resolveEscal).unwrap();

      setOpenModal(false);
      setError('');
      setInternalNote('');

      getJobInfo();

      history.push("/dashboard/admintools?tab_index=0") 

    } 
    catch (validationError) {
      setError(validationError.message); 
    }
 
  };
  
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: 'none',
    borderRadius: '1.5em',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  };

  return (

    <div>

      <Button 
        variant="contained" 
        color="primary" 
        onClick={handleOpenModal} 
        disabled={!userCanEditJob}
        style={{ margin: '0 0 0 1em' }}
      >
        Save And Set As Active
      </Button>

      <Modal open={open} onClose={handleCloseModal}>

        <Box sx={modalStyle}>

          <img src={alertIcon} alt='alert icon' height='32px' />

          <Typography variant="h6" component="h2" align="center" style={{margin: '0.5em 0 1em 0'}} >
            ¿Are you sure you want to save <br/> this job and set it as active?
          </Typography>

          <div>Internal Note:</div>

          <TextField
            multiline
            rows={4}
            variant="outlined"
            fullWidth
            value={internalNote}
            onChange={(e) => setInternalNote(e.target.value)}
            error={!!error}
            helperText={error} 
          />

          <Box display="flex" justifyContent="center" mt={2}>

            <Button
              variant="contained"
              color="secondary"
              onClick={handleCloseModal}
              style={{ marginRight: '2em', width: '100px' }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={SaveChanges}
              style={{ width: '100px' }}
            > {
              fetching ? (
                <CircularProgress sx={{ color: 'white' }} size={24} />
              ) : (
              "Accept"
              )}
            </Button>

          </Box>

        </Box>

      </Modal>

    </div>

  );

};

export default SaveAndSetAsActive;
